import React from 'react';
import cn from 'classnames';

import ChargeItem from '../../../components/common/features/ChargeItem';
import Button from '../../../components/common/ui/Button';
import Loader from '../../../components/common/ui/Loader';

import styles from './styles.module.scss';

const ChargesList = ({
  charges,
  changeCursor,
  prevCursor,
  nextCursor,
  type,
  loading,
}) => {
  if (loading) {
    return (
      <div className={styles.loader}>
        <Loader show={loading} />
      </div>
    );
  }

  return charges?.length > 0 ? (
    <>
      <ul className={styles.items}>
        {charges.map((charge, index) => (
          <li key={index}>
            <ChargeItem
              type={type}
              data-cy={`${type}-charges`}
              key={index}
              chargeInfo={charge}
            ></ChargeItem>
          </li>
        ))}
      </ul>
      {(prevCursor || nextCursor) && (
        <div className={styles.buttonsWrapper}>
          {prevCursor && (
            <Button
              data-cy={`${type}-prev-btn`}
              onClick={() => changeCursor(prevCursor)}
            >
              previous page
            </Button>
          )}
          {nextCursor && (
            <Button
              data-cy={`${type}-next-btn`}
              onClick={() => changeCursor(nextCursor)}
            >
              next page
            </Button>
          )}
        </div>
      )}
      {type === 'upcoming' && (
        <p className={cn('text-s', styles.taxesNote)}>
          *Charges displayed excludes taxes. You may see a different charge
          amount on your account once the payment is processed.
        </p>
      )}
    </>
  ) : (
    <p>No {type} charges yet</p>
  );
};

export default ChargesList;
